export default {
    mindfulMinutes: {
        create: {
            title: 'Plan New Mindful Moment',
            successMessage: 'New Mindful Moment has been added'
        },
        view: {
            listTitle: 'Mindful Moments',
            title: 'Mindful Moment',
            themes: [
                'intro',
                'stress',
                'relationships',
                'productivity',
                'leadership',
                'focus',
                'creativity',
                'rest',
                'yoga',
                'workshops'
            ]
        },
        edit: {
            title: 'Edit Meditation',
            successMessage: 'Mindful Moment has been updated',
            successMessageAvatar: 'Mindful Moment image has been updated',
            errorMessageAvatar: 'Mindful Moment image is required',
            errorMessageStartedAt:
                'You can`t plan meditation less than 10 min before the live stream should start',
            delete: {
                button: 'Delete',
                successMessage: 'The session has been deleted'
            }
        }
    }
};
